import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=0b585d9a&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"
import style0 from "./Form2.vue?vue&type=style&index=0&id=0b585d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b585d9a",
  null
  
)

export default component.exports